
export const optionSource = function (lang) {
    return [
        // Overview
        { id: 1, label:lang==='fa'?"بازده روز": '1 Day Performance', key: 'return1d', value: null, numType: 'percent' },
        { id: 2, label:lang==='fa'?"بازده 1 هفته": '1 Week Performance', key: 'return1W', value: null, numType: 'percent' },
        { id: 3, label:lang==='fa'?"بازده 1 ماه ": '1 Month Performance', key: 'return1M', value: null, numType: 'percent' },
        { id: 4, label:lang==='fa'?"بازده 3 ماه": '3 Month Performance', key: 'return3M', value: null, numType: 'percent' },
        { id: 5, label:lang==='fa'?"بازده 6 ماه": '6 Month Performance', key: 'return6M', value: null, numType: 'percent' },
        { id: 6, label:lang==='fa'?"بازده 1 سال": '1 Year Performance', key: 'return1Y', value: null, numType: 'percent' },
        { id: 7, label:lang==='fa'?"بازده از ابتدای سال میلادی": 'YTD Performance', key: 'returnYTD', value: null, numType: 'percent' },
        // .....
        { id: 41, label: lang==='fa'?"بتا":'BETA', key: 'beta', value: null, numType: 'number' },
        // Multiple
        { id: 8,  label: 'P/E (ttm)', key: 'p2e', value: null, numType: 'number' },
        { id: 10, label: 'P/S', key: 'p2s', value: null, numType: 'number' },
        { id: 11, label: 'P/B', key: 'p2b', value: null, numType: 'number' },               
        // Key Stats
        { id: 16, label:'ROA', key: 'roa', value: null, numType: 'percent' },
        { id: 17, label:'ROE', key: 'roe', value: null, numType: 'percent' },
        { id: 25, label: lang==='fa'?"نسبت پرداخت سود":'Payout Ratio', key: 'payoutRatio', value: null, numType: 'percent' },
        { id: 12, label: lang==='fa'?"بازده نقدی":'Dividend Yield', key: 'dividendYield', value: null, numType: 'percent' },
        // Growth Rate
        { id: 29, label: lang==='fa'?"نرخ رشد 1 ساله سود خالص":'NI 1 Year Growth Rate', key: 'growthRate1yEps', value: null, numType: 'percent' },
        { id: 30, label: lang==='fa'?"نرخ رشد 3 ساله سود خالص":'NI 3 Years Growth Rate', key: 'growthRate3yEps', value: null, numType: 'percent' },
        { id: 31, label: lang==='fa'?"نرخ رشد 5 ساله سود خالص":'NI 5 Years Growth Rate', key: 'growthRate5yEps', value: null, numType: 'percent' },
        { id: 26, label: lang==='fa'?"نرخ رشد 1 ساله درآمد":'Revenue 1 Year Growth Rate', key: 'growthRate1yRevenue', value: null, numType: 'percent' },
        { id: 27, label: lang==='fa'?"نرخ رشد 3 ساله درآمد":'Revenue 3 Years Growth Rate', key: 'growthRate3yRevenue', value: null, numType: 'percent' },
        { id: 28, label: lang==='fa'?"نرخ رشد 5 ساله درآمد":'Revenue 5 Years Growth Rate', key: 'growthRate5yRevenue', value: null, numType: 'percent' },
        { id: 35, label: lang==='fa'?"نرخ رشد درآمد فصل آخر نسبت به مشابه سال قبل":'Revenue Qtrly GR YoY', key: 'growthrateRevenueYoy', value: null, numType: 'percent' },
        { id: 36, label: lang==='fa'?"نرخ رشد درآمد فصل آخر نسبت به فصل قبل":'Revenue Qtrly GR QoQ', key: 'growthrateRevenueQoq', value: null, numType: 'percent' },
        { id: 37, label: lang==='fa'?"نرخ رشد سود خالص فصل آخر نسبت به مشابه سال قبل":'NI Qtrly GR YoY', key: 'growthrateNetIncomeLossYoy', value: null, numType: 'percent' },
        { id: 38, label: lang==='fa'?"نرخ رشد سود خالص فصل آخر نسبت به فصل قبل":'NI Qtrly GR QoQ', key: 'growthrateNetIncomeLossQoq', value: null, numType: 'percent' },              
    ];
}
export const areaOptionSource = function (lang) {
    return [
        { id: 4,  label: lang==='fa'?"ارزش معاملات روز":'Current Value', key: 'value' },
        { id: 3,  label: lang==='fa'?"حجم معاملات روز":'Current Volume', key: 'volume' },
        { id: 1,  label: lang==='fa'?"ارزش بازار":'Market Cap', key: 'marketCap' },
        { id: 2,  label: lang==='fa'?"ارزش بازار شناور":'Free-Float Market Cap', key: 'freeMarketCap' },
        { id: 5,  label: lang==='fa'?"میانگین حجم معاملات 5 روز":'5 Day Average Volume', key: 'avgvol5d' },
        { id: 6,  label: lang==='fa'?"میانگین حجم معاملات 30 روز":'30 Day Average Volume', key: 'avgvol30d' },
        { id: 7,  label: lang==='fa'?"میانگین حجم معاملات 90 روز":'90 Day Average Volume', key: 'avgvol90d' },
        { id: 8,  label: lang==='fa'?"میانگین حجم معاملات 200 روز":'200 Day Average Volume', key: 'avgvol200d' },
        { id: 9,  label: lang==='fa'?"میانگین ارزش معاملات 5 روز":'5 Days Average Value', key: 'avgval5d' },
        { id: 10, label: lang==='fa'?"میانگین ارزش معاملات 30 روز":'30 Days Average Value', key: 'avgval30d' },
        { id: 11, label: lang==='fa'?"میانگین ارزش معاملات 90 روز":'90 Days Average Value', key: 'avgval90d' },
        { id: 12, label: lang==='fa'?"میانگین ارزش معاملات 200 روز":'200 Days Average Value', key: 'avgval200d' },
        { id: 13, label: lang==='fa'?"اندازه یکسان":'Equal Size', key: 'sameSize' },
    ];
}
export const exchangeTypesSource = function (lang) {

    return [
        { id: 3, label: lang==='fa'?"کل بازار":"All" },
        { id: 1, label: lang==='fa'?"بورس":"TSE" },
        { id: 2, label: lang==='fa'?"فرابورس":"IFB" },
        { id: 3, label: lang==='fa'?"فرابورس-پایه":"IFB-OTC" }
    ];
}






































































// //2347 total


// export const mapData1 = [
//   {
//     scale: 440,
//     text: 'stock1',
//     industries: [
//       {
//         scale: 100,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 30,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 40,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 30,
//             text: 'stock113',
//             names: [

//             ]
//           },
//         ]
//       },
//       {
//         scale: 140,
//         text: 'stock12',
//         tickers: [
//           {
//             scale: 20,
//             text: 'stock121',
//             names: [

//             ]
//           },
//           {
//             scale: 40,
//             text: 'stock122',
//             names: [

//             ]
//           },
//           {
//             scale: 30,
//             text: 'stock123',
//             names: [

//             ]
//           },
//           {
//             scale: 50,
//             text: 'stock124',
//             names: [

//             ]
//           },
//         ]
//       },
//       {
//         scale: 200,
//         text: 'stock13',
//         tickers: [
//           {
//             scale: 10,
//             text: 'stock131',
//             names: [

//             ]
//           },
//           {
//             scale: 20,
//             text: 'stock132',
//             names: [

//             ]
//           },
//           {
//             scale: 80,
//             text: 'stock133',
//             names: [

//             ]
//           },
//           {
//             scale: 90,
//             text: 'stock134',
//             names: [

//             ]
//           },
//         ]
//       },
//     ]
//   },
//   {
//     scale: 620,
//     text: 'stock2',
//     industries: [
//       {
//         scale: 400,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 220,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 140,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 40,
//             text: 'stock113',
//             names: [

//             ]
//           },
//         ]
//       },
//       {
//         scale: 220,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 50,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 140,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 30,
//             text: 'stock113',
//             names: [

//             ]
//           },
//         ]
//       }
//     ]
//   },
//   {
//     scale: 35,
//     text: 'stock3',
//     industries: [
//       {
//         scale: 35,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 10,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 10,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 15,
//             text: 'stock113',
//             names: [

//             ]
//           },
//         ]
//       }
//     ]
//   },
//   {
//     scale: 165,
//     text: 'stock4',
//     industries: [
//       {
//         scale: 100,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 30,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 40,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 30,
//             text: 'stock113',
//             names: [

//             ]
//           },
//         ]
//       },
//       {
//         scale: 65,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 30,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 20,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 15,
//             text: 'stock113',
//             names: [

//             ]
//           },
//         ]
//       }
//     ]
//   },
//   {
//     scale: 570,
//     text: 'stock5',
//     industries: [
//       {
//         scale: 350,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 100,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 200,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 30,
//             text: 'stock113',
//             names: [

//             ]
//           }
//         ]
//       },
//       {
//         scale: 220,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 100,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 100,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 20,
//             text: 'stock113',
//             names: [

//             ]
//           }
//         ]
//       }
//     ] 
//   },
//   {
//     scale: 92,
//     text: 'stock6',
//     industries: [
//       {
//         scale: 92,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 10,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 10,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 42,
//             text: 'stock113',
//             names: [

//             ]
//           },
//         ]
//       }
//     ]
//   },
//   {
//     scale: 235,
//     text: 'stock7',
//     industries: [
//       {
//         scale: 100,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 30,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 40,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 30,
//             text: 'stock113',
//             names: [

//             ]
//           },
//         ]
//       },
//       {
//         scale: 135,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 65,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 40,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 30,
//             text: 'stock113',
//             names: [

//             ]
//           },
//         ]
//       }
//     ]
//   },
//   {
//     scale: 190,
//     text: 'stock8',
//     industries: [
//       {
//         scale: 190,
//         text: 'stock11',
//         tickers: [
//           {
//             scale: 70,
//             text: 'stock111',
//             names: [

//             ]
//           },
//           {
//             scale: 50,
//             text: 'stock112',
//             names: [

//             ]
//           },
//           {
//             scale: 42,
//             text: 'stock113',
//             names: [

//             ]
//           },
//         ]
//       }
//     ]
//   }
// ]






// export const mapData2 = [
//   {
//     value: 440,
//     text: 'stock1',
//     children: [
//       {
//         value: 100,
//         text: 'stock11',
//         children: [
//           {
//             value: 30,
//             text: 'stock111',
//             children: [

//             ]
//           },
//           {
//             value: 40,
//             text: 'stock112',
//             children: [

//             ]
//           },
//           {
//             value: 30,
//             text: 'stock113',
//             children: [

//             ]
//           },
//         ]
//       },
//       {
//         value: 140,
//         text: 'stock12',
//         children: [
//           {
//             value: 20,
//             text: 'stock121',
//             children: [

//             ]
//           },
//           {
//             value: 40,
//             text: 'stock122',
//             children: [

//             ]
//           },
//           {
//             value: 30,
//             text: 'stock123',
//             children: [

//             ]
//           },
//           {
//             value: 50,
//             text: 'stock124',
//             children: [

//             ]
//           },
//         ]
//       },
//       {
//         value: 200,
//         text: 'stock13',
//         children: [
//           {
//             value: 10,
//             text: 'stock131',
//             children: [

//             ]
//           },
//           {
//             value: 20,
//             text: 'stock132',
//             children: [

//             ]
//           },
//           {
//             value: 80,
//             text: 'stock133',
//             children: [

//             ]
//           },
//           {
//             value: 90,
//             text: 'stock134',
//             children: [

//             ]
//           },
//         ]
//       },
//     ]
//   },
//   {
//     value: 620,
//     text: 'stock2',
//     children: [
//       {
//         value: 220,
//         text: 'stock21',
//         children: [
//           {
//             value: 20,
//             text: 'stock211',
//             children: [

//             ]
//           },
//           {
//             value: 150,
//             text: 'stock212',
//             children: [

//             ]
//           },
//           {
//             value: 50,
//             text: 'stock213',
//             children: [

//             ]
//           },
//         ]
//       },
//       {
//         value: 180,
//         text: 'stock22',
//         children: [
//           {
//             value: 20,
//             text: 'stock221',
//             children: [

//             ]
//           },
//           {
//             value: 100,
//             text: 'stock222',
//             children: [

//             ]
//           },
//           {
//             value: 20,
//             text: 'stock223',
//             children: [

//             ]
//           },
//           {
//             value: 40,
//             text: 'stock224',
//             children: [

//             ]
//           },
//         ]
//       },
//       {
//         value: 160,
//         text: 'stock23',
//         children: [
//           {
//             value: 50,
//             text: 'stock231',
//             children: [

//             ]
//           },
//           {
//             value: 20,
//             text: 'stock232',
//             children: [

//             ]
//           },
//           {
//             value: 10,
//             text: 'stock233',
//             children: [

//             ]
//           },
//           {
//             value: 80,
//             text: 'stock234',
//             children: [

//             ]
//           },
//         ]
//       },
//       {
//         value: 60,
//         text: 'stock24',
//         children: [
//           {
//             value: 10,
//             text: 'stock241',
//             children: [
//             ]

//           },
//           {
//             value: 20,
//             text: 'stock242',
//             children: [

//             ]
//           },
//           {
//             value: 5,
//             text: 'stock243',
//             children: [

//             ]
//           },
//           {
//             value: 25,
//             text: 'stock244',
//             children: [

//             ]
//           },
//         ]
//       },
//     ]
//   },
//   {
//     value: 35,
//     text: 'stock3',
//     children: []
//   },
//   {
//     value: 65,
//     text: 'stock4',
//     children: []
//   }
// ]


// export const myData = [
//   {
//     "title": "sector 1",
//     "color": "#12939A",
//     "value": 1888,
//     "children": [
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       }
//     ]
//   },
//   {
//     "title": "sector 2",
//     "color": "#12939A",
//     "value": 1888,
//     "children": [
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       }
//     ]
//   },
//   {
//     "title": "sector 3",
//     "color": "#12939A",
//     "value": 1888,
//     "children": [
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       }
//     ]
//   },
//   {
//     "title": "sector 4",
//     "color": "#12939A",
//     "value": 1888,
//     "children": [
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       }
//     ]
//   },
//   {
//     "title": "sector 5",
//     "color": "#12939A",
//     "value": 1888,
//     "children": [
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       }
//     ]
//   },
//   {
//     "title": "sector 6",
//     "color": "#12939A",
//     "value": 1888,
//     "children": [
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       }
//     ]
//   },
//   {
//     "title": "sector 7",
//     "color": "#12939A",
//     "value": 1888,
//     "children": [
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       },
//       {
//         "title": "analytics",
//         "color": "#12939A",
//         "value": 472,
//         "children": [
//           {
//             "title": "cluster",
//             "color": "#12939A",
//             "value": 137,
//             "children": [
//               { "title": "AgglomerativeCluster", "color": "#12939A", "value": 40 },
//               { "title": "CommunityStructure", "color": "#12939A", "value": 30 },
//               { "title": "HierarchicalCluster", "color": "#12939A", "value": 60 },
//               { "title": "MergeEdge", "color": "#12939A", "value": 7 }
//             ]
//           },
//           {
//             "title": "graph",
//             "color": "#12939A",
//             "value": 235,
//             "children": [
//               { "title": "BetweennessCentrality", "color": "#12939A", "value": 35 },
//               { "title": "LinkDistance", "color": "#12939A", "value": 50 },
//               { "title": "MaxFlowMinCut", "color": "#12939A", "value": 70 },
//               { "title": "ShortestPaths", "color": "#12939A", "value": 50 },
//               { "title": "SpanningTree", "color": "#12939A", "value": 30 }
//             ]
//           },
//           {
//             "title": "optimization",
//             "color": "#12939A",
//             "value": 100,
//             "children": [
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 70 },
//               { "title": "AspectRatioBanker", "color": "#12939A", "value": 30 }
//             ]
//           }
//         ]
//       }
//     ]
//   }
// ]


// export const rootHtml = {
//   "root": {
//     "name": "nivo",
//     "color": "hsl(330, 70%, 50%)",
//     "children": [
//       {
//         "name": "viz",
//         "color": "hsl(294, 70%, 50%)",
//         "children": [
//           {
//             "name": "stack",
//             "color": "hsl(183, 70%, 50%)",
//             "children": [
//               {
//                 "name": "chart",
//                 "color": "hsl(218, 70%, 50%)",
//                 "loc": 196412
//               },
//               {
//                 "name": "xAxis",
//                 "color": "hsl(98, 70%, 50%)",
//                 "loc": 18902
//               },
//               {
//                 "name": "yAxis",
//                 "color": "hsl(217, 70%, 50%)",
//                 "loc": 106074
//               },
//               {
//                 "name": "layers",
//                 "color": "hsl(238, 70%, 50%)",
//                 "loc": 130953
//               }
//             ]
//           },
//           {
//             "name": "pie",
//             "color": "hsl(150, 70%, 50%)",
//             "children": [
//               {
//                 "name": "chart",
//                 "color": "hsl(96, 70%, 50%)",
//                 "children": [
//                   {
//                     "name": "pie",
//                     "color": "hsl(37, 70%, 50%)",
//                     "children": [
//                       {
//                         "name": "outline",
//                         "color": "hsl(171, 70%, 50%)",
//                         "loc": 8490
//                       },
//                       {
//                         "name": "slices",
//                         "color": "hsl(296, 70%, 50%)",
//                         "loc": 34384
//                       },
//                       {
//                         "name": "bbox",
//                         "color": "hsl(15, 70%, 50%)",
//                         "loc": 21573
//                       }
//                     ]
//                   },
//                   {
//                     "name": "donut",
//                     "color": "hsl(205, 70%, 50%)",
//                     "loc": 154304
//                   },
//                   {
//                     "name": "gauge",
//                     "color": "hsl(345, 70%, 50%)",
//                     "loc": 6898
//                   }
//                 ]
//               },
//               {
//                 "name": "legends",
//                 "color": "hsl(43, 70%, 50%)",
//                 "loc": 110593
//               }
//             ]
//           }
//         ]
//       },
//       {
//         "name": "colors",
//         "color": "hsl(24, 70%, 50%)",
//         "children": [
//           {
//             "name": "rgb",
//             "color": "hsl(192, 70%, 50%)",
//             "loc": 68094
//           },
//           {
//             "name": "hsl",
//             "color": "hsl(25, 70%, 50%)",
//             "loc": 30811
//           }
//         ]
//       },
//       {
//         "name": "utils",
//         "color": "hsl(186, 70%, 50%)",
//         "children": [
//           {
//             "name": "randomize",
//             "color": "hsl(88, 70%, 50%)",
//             "loc": 193114
//           },
//           {
//             "name": "resetClock",
//             "color": "hsl(9, 70%, 50%)",
//             "loc": 113046
//           },
//           {
//             "name": "noop",
//             "color": "hsl(185, 70%, 50%)",
//             "loc": 130386
//           },
//           {
//             "name": "tick",
//             "color": "hsl(29, 70%, 50%)",
//             "loc": 73057
//           },
//           {
//             "name": "forceGC",
//             "color": "hsl(1, 70%, 50%)",
//             "loc": 11310
//           },
//           {
//             "name": "stackTrace",
//             "color": "hsl(219, 70%, 50%)",
//             "loc": 80575
//           },
//           {
//             "name": "dbg",
//             "color": "hsl(99, 70%, 50%)",
//             "loc": 135279
//           }
//         ]
//       },
//       {
//         "name": "generators",
//         "color": "hsl(216, 70%, 50%)",
//         "children": [
//           {
//             "name": "address",
//             "color": "hsl(29, 70%, 50%)",
//             "loc": 199577
//           },
//           {
//             "name": "city",
//             "color": "hsl(316, 70%, 50%)",
//             "loc": 101883
//           },
//           {
//             "name": "animal",
//             "color": "hsl(179, 70%, 50%)",
//             "loc": 139696
//           },
//           {
//             "name": "movie",
//             "color": "hsl(189, 70%, 50%)",
//             "loc": 164805
//           },
//           {
//             "name": "user",
//             "color": "hsl(352, 70%, 50%)",
//             "loc": 20525
//           }
//         ]
//       },
//       {
//         "name": "set",
//         "color": "hsl(69, 70%, 50%)",
//         "children": [
//           {
//             "name": "clone",
//             "color": "hsl(42, 70%, 50%)",
//             "loc": 17338
//           },
//           {
//             "name": "intersect",
//             "color": "hsl(124, 70%, 50%)",
//             "loc": 156324
//           },
//           {
//             "name": "merge",
//             "color": "hsl(333, 70%, 50%)",
//             "loc": 122358
//           },
//           {
//             "name": "reverse",
//             "color": "hsl(161, 70%, 50%)",
//             "loc": 72365
//           },
//           {
//             "name": "toArray",
//             "color": "hsl(194, 70%, 50%)",
//             "loc": 94427
//           },
//           {
//             "name": "toObject",
//             "color": "hsl(180, 70%, 50%)",
//             "loc": 63293
//           },
//           {
//             "name": "fromCSV",
//             "color": "hsl(263, 70%, 50%)",
//             "loc": 173139
//           },
//           {
//             "name": "slice",
//             "color": "hsl(42, 70%, 50%)",
//             "loc": 126842
//           },
//           {
//             "name": "append",
//             "color": "hsl(123, 70%, 50%)",
//             "loc": 67702
//           },
//           {
//             "name": "prepend",
//             "color": "hsl(38, 70%, 50%)",
//             "loc": 142386
//           },
//           {
//             "name": "shuffle",
//             "color": "hsl(63, 70%, 50%)",
//             "loc": 58932
//           },
//           {
//             "name": "pick",
//             "color": "hsl(290, 70%, 50%)",
//             "loc": 138989
//           },
//           {
//             "name": "plouc",
//             "color": "hsl(266, 70%, 50%)",
//             "loc": 124778
//           }
//         ]
//       },
//       {
//         "name": "text",
//         "color": "hsl(130, 70%, 50%)",
//         "children": [
//           {
//             "name": "trim",
//             "color": "hsl(28, 70%, 50%)",
//             "loc": 29741
//           },
//           {
//             "name": "slugify",
//             "color": "hsl(171, 70%, 50%)",
//             "loc": 4047
//           },
//           {
//             "name": "snakeCase",
//             "color": "hsl(39, 70%, 50%)",
//             "loc": 10589
//           },
//           {
//             "name": "camelCase",
//             "color": "hsl(285, 70%, 50%)",
//             "loc": 3101
//           },
//           {
//             "name": "repeat",
//             "color": "hsl(287, 70%, 50%)",
//             "loc": 199592
//           },
//           {
//             "name": "padLeft",
//             "color": "hsl(212, 70%, 50%)",
//             "loc": 105814
//           },
//           {
//             "name": "padRight",
//             "color": "hsl(31, 70%, 50%)",
//             "loc": 38638
//           },
//           {
//             "name": "sanitize",
//             "color": "hsl(141, 70%, 50%)",
//             "loc": 132961
//           },
//           {
//             "name": "ploucify",
//             "color": "hsl(242, 70%, 50%)",
//             "loc": 79487
//           }
//         ]
//       },
//       {
//         "name": "misc",
//         "color": "hsl(250, 70%, 50%)",
//         "children": [
//           {
//             "name": "whatever",
//             "color": "hsl(138, 70%, 50%)",
//             "children": [
//               {
//                 "name": "hey",
//                 "color": "hsl(10, 70%, 50%)",
//                 "loc": 88312
//               },
//               {
//                 "name": "WTF",
//                 "color": "hsl(120, 70%, 50%)",
//                 "loc": 132421
//               },
//               {
//                 "name": "lol",
//                 "color": "hsl(266, 70%, 50%)",
//                 "loc": 91356
//               },
//               {
//                 "name": "IMHO",
//                 "color": "hsl(72, 70%, 50%)",
//                 "loc": 119469
//               }
//             ]
//           },
//           {
//             "name": "other",
//             "color": "hsl(354, 70%, 50%)",
//             "loc": 107003
//           },
//           {
//             "name": "crap",
//             "color": "hsl(100, 70%, 50%)",
//             "children": [
//               {
//                 "name": "crapA",
//                 "color": "hsl(159, 70%, 50%)",
//                 "loc": 3694
//               },
//               {
//                 "name": "crapB",
//                 "color": "hsl(229, 70%, 50%)",
//                 "children": [
//                   {
//                     "name": "crapB1",
//                     "color": "hsl(224, 70%, 50%)",
//                     "loc": 59997
//                   },
//                   {
//                     "name": "crapB2",
//                     "color": "hsl(194, 70%, 50%)",
//                     "loc": 155632
//                   },
//                   {
//                     "name": "crapB3",
//                     "color": "hsl(282, 70%, 50%)",
//                     "loc": 177364
//                   },
//                   {
//                     "name": "crapB4",
//                     "color": "hsl(273, 70%, 50%)",
//                     "loc": 113114
//                   }
//                 ]
//               },
//               {
//                 "name": "crapC",
//                 "color": "hsl(249, 70%, 50%)",
//                 "children": [
//                   {
//                     "name": "crapC1",
//                     "color": "hsl(193, 70%, 50%)",
//                     "loc": 7132
//                   },
//                   {
//                     "name": "crapC2",
//                     "color": "hsl(239, 70%, 50%)",
//                     "loc": 63696
//                   },
//                   {
//                     "name": "crapC3",
//                     "color": "hsl(60, 70%, 50%)",
//                     "loc": 17193
//                   },
//                   {
//                     "name": "crapC4",
//                     "color": "hsl(49, 70%, 50%)",
//                     "loc": 79403
//                   },
//                   {
//                     "name": "crapC5",
//                     "color": "hsl(59, 70%, 50%)",
//                     "loc": 27267
//                   },
//                   {
//                     "name": "crapC6",
//                     "color": "hsl(24, 70%, 50%)",
//                     "loc": 53992
//                   },
//                   {
//                     "name": "crapC7",
//                     "color": "hsl(49, 70%, 50%)",
//                     "loc": 47544
//                   },
//                   {
//                     "name": "crapC8",
//                     "color": "hsl(255, 70%, 50%)",
//                     "loc": 100445
//                   },
//                   {
//                     "name": "crapC9",
//                     "color": "hsl(112, 70%, 50%)",
//                     "loc": 58658
//                   }
//                 ]
//               }
//             ]
//           }
//         ]
//       }
//     ]
//   }
// }



// export const rootSvg = {
//   "root": {
//     "name": "nivo",
//     "color": "hsl(3, 70%, 50%)",
//     "children": [
//       {
//         "name": "viz",
//         "color": "hsl(190, 70%, 50%)",
//         "children": [
//           {
//             "name": "stack",
//             "color": "hsl(299, 70%, 50%)",
//             "children": [
//               {
//                 "name": "chart",
//                 "color": "hsl(280, 70%, 50%)",
//                 "loc": 36444
//               },
//               {
//                 "name": "xAxis",
//                 "color": "hsl(145, 70%, 50%)",
//                 "loc": 47298
//               },
//               {
//                 "name": "yAxis",
//                 "color": "hsl(268, 70%, 50%)",
//                 "loc": 91023
//               },
//               {
//                 "name": "layers",
//                 "color": "hsl(202, 70%, 50%)",
//                 "loc": 142961
//               }
//             ]
//           },
//           {
//             "name": "pie",
//             "color": "hsl(231, 70%, 50%)",
//             "children": [
//               {
//                 "name": "chart",
//                 "color": "hsl(108, 70%, 50%)",
//                 "children": [
//                   {
//                     "name": "pie",
//                     "color": "hsl(275, 70%, 50%)",
//                     "children": [
//                       {
//                         "name": "outline",
//                         "color": "hsl(47, 70%, 50%)",
//                         "loc": 189301
//                       },
//                       {
//                         "name": "slices",
//                         "color": "hsl(17, 70%, 50%)",
//                         "loc": 7839
//                       },
//                       {
//                         "name": "bbox",
//                         "color": "hsl(269, 70%, 50%)",
//                         "loc": 105799
//                       }
//                     ]
//                   },
//                   {
//                     "name": "donut",
//                     "color": "hsl(98, 70%, 50%)",
//                     "loc": 176209
//                   },
//                   {
//                     "name": "gauge",
//                     "color": "hsl(232, 70%, 50%)",
//                     "loc": 42242
//                   }
//                 ]
//               },
//               {
//                 "name": "legends",
//                 "color": "hsl(197, 70%, 50%)",
//                 "loc": 180284
//               }
//             ]
//           }
//         ]
//       },
//       {
//         "name": "colors",
//         "color": "hsl(93, 70%, 50%)",
//         "children": [
//           {
//             "name": "rgb",
//             "color": "hsl(126, 70%, 50%)",
//             "loc": 62073
//           },
//           {
//             "name": "hsl",
//             "color": "hsl(209, 70%, 50%)",
//             "loc": 122893
//           }
//         ]
//       },
//       {
//         "name": "utils",
//         "color": "hsl(38, 70%, 50%)",
//         "children": [
//           {
//             "name": "randomize",
//             "color": "hsl(23, 70%, 50%)",
//             "loc": 16923
//           },
//           {
//             "name": "resetClock",
//             "color": "hsl(184, 70%, 50%)",
//             "loc": 107366
//           },
//           {
//             "name": "noop",
//             "color": "hsl(342, 70%, 50%)",
//             "loc": 56411
//           },
//           {
//             "name": "tick",
//             "color": "hsl(260, 70%, 50%)",
//             "loc": 181864
//           },
//           {
//             "name": "forceGC",
//             "color": "hsl(47, 70%, 50%)",
//             "loc": 142200
//           },
//           {
//             "name": "stackTrace",
//             "color": "hsl(135, 70%, 50%)",
//             "loc": 126706
//           },
//           {
//             "name": "dbg",
//             "color": "hsl(193, 70%, 50%)",
//             "loc": 82252
//           }
//         ]
//       },
//       {
//         "name": "generators",
//         "color": "hsl(183, 70%, 50%)",
//         "children": [
//           {
//             "name": "address",
//             "color": "hsl(218, 70%, 50%)",
//             "loc": 114770
//           },
//           {
//             "name": "city",
//             "color": "hsl(122, 70%, 50%)",
//             "loc": 166746
//           },
//           {
//             "name": "animal",
//             "color": "hsl(92, 70%, 50%)",
//             "loc": 136717
//           },
//           {
//             "name": "movie",
//             "color": "hsl(289, 70%, 50%)",
//             "loc": 148649
//           },
//           {
//             "name": "user",
//             "color": "hsl(81, 70%, 50%)",
//             "loc": 52485
//           }
//         ]
//       },
//       {
//         "name": "set",
//         "color": "hsl(75, 70%, 50%)",
//         "children": [
//           {
//             "name": "clone",
//             "color": "hsl(288, 70%, 50%)",
//             "loc": 107691
//           },
//           {
//             "name": "intersect",
//             "color": "hsl(199, 70%, 50%)",
//             "loc": 182481
//           },
//           {
//             "name": "merge",
//             "color": "hsl(122, 70%, 50%)",
//             "loc": 183381
//           },
//           {
//             "name": "reverse",
//             "color": "hsl(269, 70%, 50%)",
//             "loc": 174597
//           },
//           {
//             "name": "toArray",
//             "color": "hsl(322, 70%, 50%)",
//             "loc": 91937
//           },
//           {
//             "name": "toObject",
//             "color": "hsl(306, 70%, 50%)",
//             "loc": 19436
//           },
//           {
//             "name": "fromCSV",
//             "color": "hsl(52, 70%, 50%)",
//             "loc": 163556
//           },
//           {
//             "name": "slice",
//             "color": "hsl(121, 70%, 50%)",
//             "loc": 135246
//           },
//           {
//             "name": "append",
//             "color": "hsl(131, 70%, 50%)",
//             "loc": 164566
//           },
//           {
//             "name": "prepend",
//             "color": "hsl(255, 70%, 50%)",
//             "loc": 143826
//           },
//           {
//             "name": "shuffle",
//             "color": "hsl(314, 70%, 50%)",
//             "loc": 109402
//           },
//           {
//             "name": "pick",
//             "color": "hsl(330, 70%, 50%)",
//             "loc": 70949
//           },
//           {
//             "name": "plouc",
//             "color": "hsl(163, 70%, 50%)",
//             "loc": 6001
//           }
//         ]
//       },
//       {
//         "name": "text",
//         "color": "hsl(90, 70%, 50%)",
//         "children": [
//           {
//             "name": "trim",
//             "color": "hsl(6, 70%, 50%)",
//             "loc": 199096
//           },
//           {
//             "name": "slugify",
//             "color": "hsl(233, 70%, 50%)",
//             "loc": 32091
//           },
//           {
//             "name": "snakeCase",
//             "color": "hsl(326, 70%, 50%)",
//             "loc": 27425
//           },
//           {
//             "name": "camelCase",
//             "color": "hsl(310, 70%, 50%)",
//             "loc": 140916
//           },
//           {
//             "name": "repeat",
//             "color": "hsl(71, 70%, 50%)",
//             "loc": 81121
//           },
//           {
//             "name": "padLeft",
//             "color": "hsl(120, 70%, 50%)",
//             "loc": 171454
//           },
//           {
//             "name": "padRight",
//             "color": "hsl(170, 70%, 50%)",
//             "loc": 23042
//           },
//           {
//             "name": "sanitize",
//             "color": "hsl(190, 70%, 50%)",
//             "loc": 157749
//           },
//           {
//             "name": "ploucify",
//             "color": "hsl(120, 70%, 50%)",
//             "loc": 101614
//           }
//         ]
//       },
//       {
//         "name": "misc",
//         "color": "hsl(263, 70%, 50%)",
//         "children": [
//           {
//             "name": "whatever",
//             "color": "hsl(264, 70%, 50%)",
//             "children": [
//               {
//                 "name": "hey",
//                 "color": "hsl(205, 70%, 50%)",
//                 "loc": 171123
//               },
//               {
//                 "name": "WTF",
//                 "color": "hsl(261, 70%, 50%)",
//                 "loc": 24807
//               },
//               {
//                 "name": "lol",
//                 "color": "hsl(194, 70%, 50%)",
//                 "loc": 38821
//               },
//               {
//                 "name": "IMHO",
//                 "color": "hsl(75, 70%, 50%)",
//                 "loc": 71991
//               }
//             ]
//           },
//           {
//             "name": "other",
//             "color": "hsl(112, 70%, 50%)",
//             "loc": 174972
//           },
//           {
//             "name": "crap",
//             "color": "hsl(232, 70%, 50%)",
//             "children": [
//               {
//                 "name": "crapA",
//                 "color": "hsl(167, 70%, 50%)",
//                 "loc": 127062
//               },
//               {
//                 "name": "crapB",
//                 "color": "hsl(205, 70%, 50%)",
//                 "children": [
//                   {
//                     "name": "crapB1",
//                     "color": "hsl(237, 70%, 50%)",
//                     "loc": 197725
//                   },
//                   {
//                     "name": "crapB2",
//                     "color": "hsl(264, 70%, 50%)",
//                     "loc": 135872
//                   },
//                   {
//                     "name": "crapB3",
//                     "color": "hsl(309, 70%, 50%)",
//                     "loc": 29485
//                   },
//                   {
//                     "name": "crapB4",
//                     "color": "hsl(229, 70%, 50%)",
//                     "loc": 188738
//                   }
//                 ]
//               },
//               {
//                 "name": "crapC",
//                 "color": "hsl(41, 70%, 50%)",
//                 "children": [
//                   {
//                     "name": "crapC1",
//                     "color": "hsl(282, 70%, 50%)",
//                     "loc": 184741
//                   },
//                   {
//                     "name": "crapC2",
//                     "color": "hsl(109, 70%, 50%)",
//                     "loc": 122764
//                   },
//                   {
//                     "name": "crapC3",
//                     "color": "hsl(3, 70%, 50%)",
//                     "loc": 133294
//                   },
//                   {
//                     "name": "crapC4",
//                     "color": "hsl(348, 70%, 50%)",
//                     "loc": 147826
//                   },
//                   {
//                     "name": "crapC5",
//                     "color": "hsl(221, 70%, 50%)",
//                     "loc": 126446
//                   },
//                   {
//                     "name": "crapC6",
//                     "color": "hsl(230, 70%, 50%)",
//                     "loc": 77736
//                   },
//                   {
//                     "name": "crapC7",
//                     "color": "hsl(257, 70%, 50%)",
//                     "loc": 54045
//                   },
//                   {
//                     "name": "crapC8",
//                     "color": "hsl(69, 70%, 50%)",
//                     "loc": 171389
//                   },
//                   {
//                     "name": "crapC9",
//                     "color": "hsl(274, 70%, 50%)",
//                     "loc": 124885
//                   }
//                 ]
//               }
//             ]
//           }
//         ]
//       }
//     ]
//   }
// }







// export const rootCanvas = {
//   "root": {
//     "name": "root",
//     "children": [
//       {
//         "name": "node.0",
//         "value": 13690,
//         "children": [
//           {
//             "name": "node.01",
//             "value": 13690,
//             "children": [
//               {
//                 "name": "node.001",
//                 "value": 13690
//               },
//               {
//                 "name": "node.002",
//                 "value": 68320
//               },
//             ]
//           },
//           {
//             "name": "node.02",
//             "value": 68320
//           },
//         ]
//       },
//       {
//         "name": "node.1",
//         "value": 68320
//       },
//       {
//         "name": "node.2",
//         "value": 40502
//       },
//       {
//         "name": "node.3",
//         "value": 25820
//       },
//       {
//         "name": "node.4",
//         "value": 1598
//       },
//       {
//         "name": "node.5",
//         "value": 69222
//       },
//       {
//         "name": "node.6",
//         "value": 70792
//       },
//       {
//         "name": "node.7",
//         "value": 39450
//       },
//       {
//         "name": "node.8",
//         "value": 94627
//       },
//       {
//         "name": "node.9",
//         "value": 96284
//       },
//       {
//         "name": "node.10",
//         "value": 57204
//       },
//       {
//         "name": "node.11",
//         "value": 47905
//       },
//       {
//         "name": "node.12",
//         "value": 22891
//       },
//       {
//         "name": "node.13",
//         "value": 90443
//       },
//       {
//         "name": "node.14",
//         "value": 41352
//       },
//       {
//         "name": "node.15",
//         "value": 26515
//       },
//       {
//         "name": "node.16",
//         "value": 31481
//       },
//       {
//         "name": "node.17",
//         "value": 54918
//       },
//       {
//         "name": "node.18",
//         "value": 88084
//       },
//       {
//         "name": "node.19",
//         "value": 67853
//       },
//       {
//         "name": "node.20",
//         "value": 4272
//       },
//       {
//         "name": "node.21",
//         "value": 83427
//       },
//       {
//         "name": "node.22",
//         "value": 7512
//       }
//     ]
//   },
// }


// const makeColorOptionSource = function (lang) {
//     return [
//         // Overview
//         { id: 1, label:lang==='fa'?"بازده روز": '1 Day Performance', key: 'return1d', value: null, numType: 'percent' },
//         { id: 2, label:lang==='fa'?"بازده 1 هفته": '1 Week Performance', key: 'return1W', value: null, numType: 'percent' },
//         { id: 3, label:lang==='fa'?"بازده 1 ماه ": '1 Month Performance', key: 'return1M', value: null, numType: 'percent' },
//         { id: 4, label:lang==='fa'?"بازده 3 ماه": '3 Month Performance', key: 'return3M', value: null, numType: 'percent' },
//         { id: 5, label:lang==='fa'?"بازده 6 ماه": '6 Month Performance', key: 'return6M', value: null, numType: 'percent' },
//         { id: 6, label:lang==='fa'?"بازده 1 سال": '1 Year Performance', key: 'return1Y', value: null, numType: 'percent' },
//         { id: 7, label:lang==='fa'?"بازده از ابتدای سال میلادی": 'YTD Performance', key: 'returnYTD', value: null, numType: 'percent' },
//         // .....
//         { id: 41, label: lang==='fa'?"بتا":'BETA', key: 'beta', value: null, numType: 'number' },
//         // Multiple
//         { id: 8,  label: 'P/E (ttm)', key: 'p2e', value: null, numType: 'number' },
//         { id: 10, label: 'P/S', key: 'p2s', value: null, numType: 'number' },
//         { id: 11, label: 'P/B', key: 'p2b', value: null, numType: 'number' },               
//         // Key Stats
//         { id: 16, label:'ROA', key: 'roa', value: null, numType: 'percent' },
//         { id: 17, label:'ROE', key: 'roe', value: null, numType: 'percent' },
//         { id: 25, label: lang==='fa'?"نسبت پرداخت سود":'Payout Ratio', key: 'payoutRatio', value: null, numType: 'percent' },
//         { id: 12, label: lang==='fa'?"بازده نقدی":'Dividend Yield', key: 'dividendYield', value: null, numType: 'percent' },
//         // Growth Rate
//         { id: 29, label: lang==='fa'?"نرخ رشد 1 ساله سود خالص":'NI 1 Year Growth Rate', key: 'growthRate1yEps', value: null, numType: 'percent' },
//         { id: 30, label: lang==='fa'?"نرخ رشد 3 ساله سود خالص":'NI 3 Years Growth Rate', key: 'growthRate3yEps', value: null, numType: 'percent' },
//         { id: 31, label: lang==='fa'?"نرخ رشد 5 ساله سود خالص":'NI 5 Years Growth Rate', key: 'growthRate5yEps', value: null, numType: 'percent' },
//         { id: 26, label: lang==='fa'?"نرخ رشد 1 ساله درآمد":'Revenue 1 Year Growth Rate', key: 'growthRate1yRevenue', value: null, numType: 'percent' },
//         { id: 27, label: lang==='fa'?"نرخ رشد 3 ساله درآمد":'Revenue 3 Years Growth Rate', key: 'growthRate3yRevenue', value: null, numType: 'percent' },
//         { id: 28, label: lang==='fa'?"نرخ رشد 5 ساله درآمد":'Revenue 5 Years Growth Rate', key: 'growthRate5yRevenue', value: null, numType: 'percent' },
//         { id: 35, label: lang==='fa'?"نرخ رشد درآمد فصل آخر نسبت به مشابه سال قبل":'Revenue Qtrly GR YoY', key: 'growthrateRevenueYoy', value: null, numType: 'percent' },
//         { id: 36, label: lang==='fa'?"نرخ رشد درآمد فصل آخر نسبت به فصل قبل":'Revenue Qtrly GR QoQ', key: 'growthrateRevenueQoq', value: null, numType: 'percent' },
//         { id: 37, label: lang==='fa'?"نرخ رشد سود خالص فصل آخر نسبت به مشابه سال قبل":'NI Qtrly GR YoY', key: 'growthrateNetIncomeLossYoy', value: null, numType: 'percent' },
//         { id: 38, label: lang==='fa'?"نرخ رشد سود خالص فصل آخر نسبت به فصل قبل":'NI Qtrly GR QoQ', key: 'growthrateNetIncomeLossQoq', value: null, numType: 'percent' },              
//     ];
// }
// const makeAreaOptionSource = function (lang) {
//     return [
//         { id: 1,  label: lang==='fa'?"ارزش بازار":'Market Cap', key: 'marketCap' },
//         { id: 2,  label: lang==='fa'?"ارزش بازار شناور":'Free-Float Market Cap', key: 'freeMarketCap' },
//         { id: 3,  label: lang==='fa'?"حجم معاملات روز":'Current Volume', key: 'volume' },
//         { id: 4,  label: lang==='fa'?"ارزش معاملات روز":'Current Value', key: 'value' },
//         { id: 5,  label: lang==='fa'?"میانگین حجم معاملات 5 روز":'5 Day Average Volume', key: 'avgvol5d' },
//         { id: 6,  label: lang==='fa'?"میانگین حجم معاملات 30 روز":'30 Day Average Volume', key: 'avgvol30d' },
//         { id: 7,  label: lang==='fa'?"میانگین حجم معاملات 90 روز":'90 Day Average Volume', key: 'avgvol90d' },
//         { id: 8,  label: lang==='fa'?"میانگین حجم معاملات 200 روز":'200 Day Average Volume', key: 'avgvol200d' },
//         { id: 9,  label: lang==='fa'?"میانگین ارزش معاملات 5 روز":'5 Days Average Value', key: 'avgval5d' },
//         { id: 10, label: lang==='fa'?"میانگین ارزش معاملات 30 روز":'30 Days Average Value', key: 'avgval30d' },
//         { id: 11, label: lang==='fa'?"میانگین ارزش معاملات 90 روز":'90 Days Average Value', key: 'avgval90d' },
//         { id: 12, label: lang==='fa'?"میانگین ارزش معاملات 200 روز":'200 Days Average Value', key: 'avgval200d' },
//         { id: 13, label: lang==='fa'?"اندازه یکسان":'Equal Size', key: 'sameSize' },
//     ];
// }
// const makeExchangeTypesSource = function (lang) {

//     return [
//         { id: 1, label: lang==='fa'?"بورس":"TSE" },
//         { id: 2, label: lang==='fa'?"فرابورس":"IFB" },
//         { id: 3, label: lang==='fa'?"فرابورس-پایه":"IFB-OTC" }
//     ];
// }

// const getMetricColors = function (metricName) {
//     var metricColor = new Map();

//     metricColor.set('return1d', [
//         { color: '#f63538', value: -3 },
//         { color: '#bf4045', value: -2 },
//         { color: '#8b444e', value: -1 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 1 },
//         { color: '#2f9e4f', value: 2 },
//         { color: '#30cc5a', value: 3 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('return1W', [
//         { color: '#f63538', value: -6 },
//         { color: '#bf4045', value: -4 },
//         { color: '#8b444e', value: -2 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 2 },
//         { color: '#2f9e4f', value: 4 },
//         { color: '#30cc5a', value: 6 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('return1M', [
//         { color: '#f63538', value: -18 },
//         { color: '#bf4045', value: -12 },
//         { color: '#8b444e', value: -6 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 6 },
//         { color: '#2f9e4f', value: 12 },
//         { color: '#30cc5a', value: 18 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('return3M', [
//         { color: '#f63538', value: -18 },
//         { color: '#bf4045', value: -12 },
//         { color: '#8b444e', value: -6 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 6 },
//         { color: '#2f9e4f', value: 12 },
//         { color: '#30cc5a', value: 18 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('return6M', [
//         { color: '#f63538', value: -18 },
//         { color: '#bf4045', value: -12 },
//         { color: '#8b444e', value: -6 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 6 },
//         { color: '#2f9e4f', value: 12 },
//         { color: '#30cc5a', value: 18 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('return1Y', [
//         { color: '#f63538', value: -30 },
//         { color: '#bf4045', value: -20 },
//         { color: '#8b444e', value: -10 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 10 },
//         { color: '#2f9e4f', value: 20 },
//         { color: '#30cc5a', value: 30 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('returnYTD', [
//         { color: '#f63538', value: -30 },
//         { color: '#bf4045', value: -20 },
//         { color: '#8b444e', value: -10 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 10 },
//         { color: '#2f9e4f', value: 20 },
//         { color: '#30cc5a', value: 30 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('p2e', [
//         { color: '#30cc5a', value: 0 },
//         { color: '#2f9e4f', value: 2 },
//         { color: '#35764e', value: 4 },
//         { color: '#414554', value: 6 },
//         { color: '#8b444e', value: 8 },
//         { color: '#bf4045', value: 10 },
//         { color: '#f63538', value: 12 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('p2ef', [
//         { color: '#30cc5a', value: 0 },
//         { color: '#2f9e4f', value: 2 },
//         { color: '#35764e', value: 4 },
//         { color: '#414554', value: 6 },
//         { color: '#8b444e', value: 8 },
//         { color: '#bf4045', value: 10 },
//         { color: '#f63538', value: 12 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('p2s', [
//         { color: '#30cc5a', value: 0 },
//         { color: '#2f9e4f', value: 0.6 },
//         { color: '#35764e', value: 1.3 },
//         { color: '#414554', value: 2 },
//         { color: '#8b444e', value: 2.7 },
//         { color: '#bf4045', value: 3.4 },
//         { color: '#f63538', value: 4 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('p2b', [
//         { color: '#30cc5a', value: 0 },
//         { color: '#2f9e4f', value: 0.6 },
//         { color: '#35764e', value: 1.3 },
//         { color: '#414554', value: 2 },
//         { color: '#8b444e', value: 2.7 },
//         { color: '#bf4045', value: 3.4 },
//         { color: '#f63538', value: 4 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('roa', [
//         { color: '#f63538', value: 0 },
//         { color: '#bf4045', value: 3 },
//         { color: '#8b444e', value: 6 },
//         { color: '#414554', value: 10 },
//         { color: '#35764e', value: 14 },
//         { color: '#2f9e4f', value: 17 },
//         { color: '#30cc5a', value: 20 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('roe', [
//         { color: '#f63538', value: 0 },
//         { color: '#bf4045', value: 6 },
//         { color: '#8b444e', value: 13 },
//         { color: '#414554', value: 20 },
//         { color: '#35764e', value: 27 },
//         { color: '#2f9e4f', value: 34 },
//         { color: '#30cc5a', value: 40 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('payoutRatio', [
//         { color: '#414554', value: 0 },
//         { color: '#3a614f', value: 20 },
//         { color: '#35764e', value: 40 },
//         { color: '#31904e', value: 50 },
//         { color: '#2fa450', value: 60 },
//         { color: '#2fb854', value: 80 },
//         { color: '#30cc5a', value: 100 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('dividendYield', [
//         { color: '#414554', value: 0 },
//         { color: '#3a614f', value: 2 },
//         { color: '#35764e', value: 4 },
//         { color: '#31904e', value: 6 },
//         { color: '#2fa450', value: 8 },
//         { color: '#2fb854', value: 10 },
//         { color: '#30cc5a', value: 12 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('growthRate1yEps', [
//         { color: '#f63538', value: -50 },
//         { color: '#bf4045', value: -33 },
//         { color: '#8b444e', value: -17 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 17 },
//         { color: '#2f9e4f', value: 33 },
//         { color: '#30cc5a', value: 50 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('growthRate3yEps', [
//         { color: '#f63538', value: -50 },
//         { color: '#bf4045', value: -33 },
//         { color: '#8b444e', value: -17 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 17 },
//         { color: '#2f9e4f', value: 33 },
//         { color: '#30cc5a', value: 50 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('growthRate5yEps', [
//         { color: '#f63538', value: -50 },
//         { color: '#bf4045', value: -33 },
//         { color: '#8b444e', value: -17 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 17 },
//         { color: '#2f9e4f', value: 33 },
//         { color: '#30cc5a', value: 50 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('growthRate1yRevenue', [
//         { color: '#f63538', value: -50 },
//         { color: '#bf4045', value: -33 },
//         { color: '#8b444e', value: -17 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 17 },
//         { color: '#2f9e4f', value: 33 },
//         { color: '#30cc5a', value: 50 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('growthRate3yRevenue', [
//         { color: '#f63538', value: -50 },
//         { color: '#bf4045', value: -33 },
//         { color: '#8b444e', value: -17 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 17 },
//         { color: '#2f9e4f', value: 33 },
//         { color: '#30cc5a', value: 50 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('growthRate5yRevenue', [
//         { color: '#f63538', value: -50 },
//         { color: '#bf4045', value: -33 },
//         { color: '#8b444e', value: -17 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 17 },
//         { color: '#2f9e4f', value: 33 },
//         { color: '#30cc5a', value: 50 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('growthrateRevenueYoy', [
//         { color: '#f63538', value: -50 },
//         { color: '#bf4045', value: -33 },
//         { color: '#8b444e', value: -17 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 17 },
//         { color: '#2f9e4f', value: 33 },
//         { color: '#30cc5a', value: 50 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('growthrateRevenueQoq', [
//         { color: '#f63538', value: -30 },
//         { color: '#bf4045', value: -20 },
//         { color: '#8b444e', value: -10 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 10 },
//         { color: '#2f9e4f', value: 20 },
//         { color: '#30cc5a', value: 30 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('growthrateNetIncomeLossYoy', [
//         { color: '#f63538', value: -50 },
//         { color: '#bf4045', value: -33 },
//         { color: '#8b444e', value: -17 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 17 },
//         { color: '#2f9e4f', value: 33 },
//         { color: '#30cc5a', value: 50 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('growthrateNetIncomeLossQoq', [
//         { color: '#f63538', value: -30 },
//         { color: '#bf4045', value: -20 },
//         { color: '#8b444e', value: -10 },
//         { color: '#414554', value: 0 },
//         { color: '#35764e', value: 10 },
//         { color: '#2f9e4f', value: 20 },
//         { color: '#30cc5a', value: 30 },
//         { color: '#000000', value: 'N/A' }
//     ]);
//     metricColor.set('beta', [
//         { color: '#26444a', value: -1.5 },
//         { color: '#25928c', value: -1 },
//         { color: '#03daca', value: -0.5 },
//         // { color: '#414554', value: 0 },
//         { color: '#fa71cd', value: 0.5 },
//         { color: '#b04e8d', value: 1 },
//         { color: '#592d48', value: 1.5 },
//         { color: '#000000', value: 'N/A' }
//     ]);

//     return metricColor.has(metricName) ? metricColor.get(metricName) : [];
// }





// export const mapData22 = [
//   {
//     color: 2.71,
//     id: "غگرجی",
//     names: [],
//     price: 100,
//     scale: 52345818878,
//     symbol: "غگرجی",
//     title: "غگرجی",
//   },
//   {
//     color: 4.1,
//     id: "غگرجی",
//     names: [],
//     price: 19500,
//     scale: 497534878,
//     symbol: "غگرجی",
//     title: "غگرجی",
//   },
//   {
//     color: 3.5,
//     id: "غگرجی",
//     names: [],
//     price: 141522,
//     scale: 12311318878,
//     symbol: "غگرجی",
//     title: "غگرجی",
//   },
//   {
//     color: 4.71,
//     id: "غگرجی",
//     names: [],
//     price: 212334,
//     scale: 69718234324,
//     symbol: "غگرجی",
//     title: "غگرجی",
//   }
// ]